// src/pages/Accounts/expenseSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchExpenses,
  fetchExpenseCode,
  saveExpense,
  deleteExpense,
  fetchHeadAccs,
} from "./expenseThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  entryDate: currentDateTime(),
  list: [],
  expenseCode: "",
  headAccs:[],
  balances: {}, // supplier balances if needed  
  loading: false,
  error: null,
  selectedExpense: null,
  isEditExpense: false,
  refreshList: false,
};

const expenseSlice = createSlice({
  name: "expenses",
  initialState,
  reducers: {
    resetExpenses: () => initialState,
    setExpenseCode: (state, action) => {
    state.expenseCode = action.payload;
    },
    setEntryDate(state, action) {
      state.entryDate = action.payload;
    },
    setSelectedExpense(state, action) {
      state.selectedExpense = action.payload;
    },
    setIsEditExpense(state, action) {
      state.isEditExpense = action.payload;
    },
    setRefreshList(state, action) {
      state.refreshList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchExpenseCode.fulfilled, (state, action) => {
        state.expenseCode = action.payload;
      })      
      .addCase(fetchHeadAccs.fulfilled, (state, action) => {
        state.headAccs = action.payload;
      })
      .addCase(saveExpense.fulfilled, (state, action) => {
        state.refreshList = true;
      })
      .addCase(deleteExpense.fulfilled, (state, action) => {
        state.list = state.list.filter((e) => e.exp_id !== action.payload.id);
      });
  },
});

export const {
  resetExpenses,
  setExpenseCode,
  setEntryDate,
  setSelectedExpense,
  setIsEditExpense,
  setRefreshList,
} = expenseSlice.actions;

export default expenseSlice.reducer;
